import React, { Component } from "react";
import PropTypes from "prop-types";

class NoResultsDialog extends Component {
  render() {
    const { onContinue, onCancel } = this.props;
    return (
      <div>
        <h2>Some results are not available</h2>
        <p>
          Would you like to continue with the available results or search again?
        </p>
        <button onClick={onContinue} onKeyDown={onContinue}>
          Continue
        </button>
        <button onClick={onCancel} onKeyDown={onCancel}>
          Search Again
        </button>
      </div>
    );
  }
}

NoResultsDialog.propTypes = {
  onContinue: PropTypes.func,
  onCancel: PropTypes.func
};

export default NoResultsDialog;



// WEBPACK FOOTER //
// ./src/components/NoResultsDialog/NoResultsDialog.js